import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-passenger-images',
  templateUrl: './passenger-images.component.html',
  styleUrls: ['./passenger-images.component.css']
})
export class PassengerImagesComponent {
  formattedPhoto: string;
  formattedSignature: string;
  fullscreenImage: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<PassengerImagesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // Format the base64 strings with proper data URL prefix    
    this.formattedPhoto = data.passenger.picture || data.passenger.photo ? `data:image/jpeg;base64,${data.passenger.picture || data.passenger.photo}` : null;
    this.formattedSignature = data.passenger.signature ? `data:image/jpeg;base64,${data.passenger.signature}` : null;    
  }

  showFullscreen(image: string): void {
    this.fullscreenImage = image;
  }

  closeFullscreen(): void {
    this.fullscreenImage = null;
  }

  deletePhoto(): void {
    this.data.passenger.picture = null;
    this.data.passenger.photo = null;
    this.formattedPhoto = null;
    this.data.onUpdate(null, this.data.passenger.signature);
  }

  deleteSignature(): void {
    this.data.passenger.signature = null;
    this.formattedSignature = null;
    if(this.data.passenger.picture) {
      this.data.onUpdate(this.data.passenger.picture, null);
    }
    if(this.data.passenger.photo) {
      this.data.onUpdate(this.data.passenger.photo, null);
    }
  }

  close(): void {
    this.dialogRef.close();
  }
} 


// WEBPACK FOOTER //
// ./src/app/shared/passenger-images/passenger-images.component.ts